/* tslint:disable */
/* eslint-disable */
import { Observable } from "rxjs";
import { filter, map } from "rxjs/operators";

import { HttpClient, HttpContext, HttpResponse } from "@angular/common/http";

import { RoleCreate } from "../../models/role-create";
import { RoleRead } from "../../models/role-read";
import { RequestBuilder } from "../../request-builder";
import { StrictHttpResponse } from "../../strict-http-response";

export interface CreateRole$Params {
  organisation_id: string;
  body: RoleCreate;
}

export function createRole(
  http: HttpClient,
  rootUrl: string,
  params: CreateRole$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<RoleRead>> {
  const rb = new RequestBuilder(rootUrl, createRole.PATH, "post");
  if (params) {
    rb.path("organisation_id", params.organisation_id, {});
    rb.body(params.body, "application/json");
  }

  // add this header so we are able to examine the failure response
  // otherwise it's intercepted by the http interceptor
  rb.header("x-ignore-interceptor", "1");

  const responseType = "json";
  return http.request(rb.build({ responseType, accept: "application/json", context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RoleRead>;
    }),
  );
}

createRole.PATH = "/surfdomeinen/organisations/{organisation_id}/auth/roles/";
